<template>
    <div>
        <b-modal
            id="m-audit-temuan-inventory"
            title="Review Audit Temuan Inventaris"
            size="lg"
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            @show="notes = ''"
        >
            <p class="text-muted">
                Auditor hanya dapat menyetujui atau menolak data perubahan SM apa adanya.
                Perbandingan data dapat dilihat pada halaman detail.
            </p>
            <b-form-group label-class="font-weight-bold">
                <template #label>
                    Catatan <small class="text-muted font-weight-normal">(wajib diisi jika ditolak)</small>
                </template>
                <b-form-textarea v-model="notes" rows="3" maxlength="1000" placeholder="Masukkan catatan" />
                <small class="text-muted">{{ notes.length }} / 1000</small>
            </b-form-group>
            <div class="text-right">
                <b-button variant="danger" class="mr-2" :disabled="isSubmitting" @click="submit('reject')">
                    Tolak
                </b-button>
                <b-button variant="success" :disabled="isSubmitting" @click="submit('approve')">
                    Setujui
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: "ModalAuditTemuan",
    props: {
        detail: { type: Object, required: true }
    },
    data() {
        return {
            notes: "",
            isSubmitting: false
        };
    },
    methods: {
        async submit(action) {
            const isReject = action === "reject";
            const notes = this.notes.trim();
            if (isReject && !notes) return this.$helper.toastError(this, "Catatan wajib diisi jika menolak");
            if (!confirm(isReject ? "Tolak data perubahan SM?" : "Setujui data perubahan SM?")) return;

            this.isSubmitting = true;
            try {
                await this.$axios.post(`inventory-variances/${this.detail.variance.id}/audit`, {
                    action,
                    notes: notes || null
                });
                this.$helper.toastSuccess(this, isReject ? "Temuan berhasil ditolak" : "Temuan berhasil disetujui");
                this.$bvModal.hide("m-audit-temuan-inventory");
                this.$emit("saved");
            } catch (error) {
                this.$helper.parseError(this, error);
            } finally {
                this.isSubmitting = false;
            }
        }
    }
};
</script>
